/**
 * ToastContainer - Rendert alle aktiven Toasts
 *
 * Platziert sich oben rechts (Desktop) oder oben zentriert unter Header (Mobile).
 * Zeigt maximal 4 Toasts gleichzeitig an.
 * Verwendet Portal für korrektes z-index Verhalten über allen Layern.
 */

import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import Toast from './Toast';
import { useNotifications } from './NotificationContext';
import './Toast.css';

const ToastContainer = memo(function ToastContainer() {
  const { toasts, dismissToast } = useNotifications();

  if (process.env.NODE_ENV === 'development' && toasts.length > 0) {
    console.log('[Toast Debug] ToastContainer render, toasts:', toasts.length);
  }

  // Maximal 4 sichtbare Toasts (neueste zuerst)
  const visibleToasts = toasts.slice(-4);

  if (visibleToasts.length === 0) {
    return null;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('[Toast Debug] Rendering visibleToasts:', visibleToasts);
  }

  return createPortal(
    <div className="toast-container" role="log" aria-live="polite">
      {visibleToasts.map((toast, index) => (
        <Toast
          key={toast.id}
          {...toast}
          index={index}
          onDismiss={dismissToast}
        />
      ))}
    </div>,
    document.body
  );
});

export default ToastContainer;
